/**
 * @typedef {'v1'|'v2'} APIVersion
 */
export const ApiVersion = {
  V1: 'v1',
  V2: 'v2',
};

export const ApiVersionDisplayText = {
  V1: 'V1 API',
  V2: 'V2 API',
};
